import { parse } from "date-fns";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function FinanceEntryValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    type: Yup.string().required(t("LABEL.required")),
    description: Yup.string().required(t("LABEL.required")),
    date: Yup.date()
      .transform(function (value, originalValue) {
        if (this.isType(value)) {
          return value;
        }
        const result = parse(originalValue, "dd/MM/yyyy", new Date());
        return result;
      })
      .typeError(t("LABEL.invalid date"))
      .required(t("LABEL.required")),
    value: Yup.string().required(t("LABEL.required")),
    fine_for_delay: Yup.string().optional(),
    interest_rate: Yup.string().optional(),
    payment_method: Yup.string().optional(),
    end_date: Yup.string().optional(),
    attachment_path: Yup.mixed().optional(),
    attachment_description: Yup.string().optional(),
    pay: Yup.string().optional(),
    payday: Yup.date()
      .transform(function (value, originalValue) {
        if (this.isType(value)) {
          return value;
        }
        const result = parse(originalValue, "dd/MM/yyyy", new Date());
        return result;
      })
      .nullable()
      .typeError(t("LABEL.invalid date"))
      .when("pay", (pay, schema) => {
        if (pay === undefined || pay === null) {
          return schema.optional();
        }

        if (Array.isArray(pay)) {
          return pay.includes("yes")
            ? schema.required(t("LABEL.required"))
            : schema.optional();
        }

        return pay === "yes"
          ? schema.required(t("LABEL.required"))
          : schema.optional();
      }),
    mode: Yup.string().required(t("LABEL.required")),
    entry: Yup.string().optional(),
    type_periodic: Yup.string().when("mode", (mode, schema) => {
      return String(mode) !== "unique"
        ? schema.required(t("LABEL.required"))
        : schema.optional();
    }),
    total_installments: Yup.string().when("mode", (mode, schema) => {
      return String(mode) !== "unique"
        ? schema.required(t("LABEL.required"))
        : schema.optional();
    }),
    accountId: Yup.string().required(t("LABEL.required")),
    categoryId: Yup.string().required(t("LABEL.required")),
    patientsId: Yup.string().optional(),
    procedureId: Yup.string().optional(),
    employeeId: Yup.string().optional(),
  });

  return validation;
}

export function UpdateFinanceEntryValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    type: Yup.string().required(t("LABEL.required")),
    description: Yup.string().required(t("LABEL.required")),
    date: Yup.date()
      .transform(function (value, originalValue) {
        if (this.isType(value)) {
          return value;
        }
        const result = parse(originalValue, "dd/MM/yyyy", new Date());
        return result;
      })
      .typeError(t("LABEL.invalid date"))
      .required(t("LABEL.required")),
    value: Yup.string().required(t("LABEL.required")),
    fine_for_delay: Yup.string().optional(),
    interest_rate: Yup.string().optional(),
    payment_method: Yup.string().optional(),
    end_date: Yup.string().optional(),
    attachment_path: Yup.mixed().optional(),
    attachment_description: Yup.string().optional(),
    pay: Yup.string().optional(),
    payday: Yup.date()
      .transform(function (value, originalValue) {
        if (this.isType(value)) {
          return value;
        }
        const result = parse(originalValue, "dd/MM/yyyy", new Date());
        return result;
      })
      .nullable()
      .typeError(t("LABEL.invalid date"))
      .when("pay", (pay, schema) => {
        if (pay === undefined || pay === null) {
          return schema.optional();
        }

        if (Array.isArray(pay)) {
          return pay.includes("yes")
            ? schema.required(t("LABEL.required"))
            : schema.optional();
        }

        return pay === "yes"
          ? schema.required(t("LABEL.required"))
          : schema.optional();
      }),
    mode: Yup.string().required(t("LABEL.required")),
    entry: Yup.string().optional(),
    type_periodic: Yup.string().optional(),
    total_installments: Yup.string().optional(),
    accountId: Yup.string().required(t("LABEL.required")),
    categoryId: Yup.string().required(t("LABEL.required")),
    patientsId: Yup.string().optional(),
    procedureId: Yup.string().optional(),
    employeeId: Yup.string().optional(),
  });

  return validation;
}
